import Api from "@root/components/api";

export default class FieldSetMutation {
    async load() {
        let query = `query {
            currentUser {    
                fieldSets {
                    id, name, public, cardCount, templateCount, gameCount
                    fields {
                        name, type,
                        i18n, multi, user, cardTemplateId cardFieldName
                    }
                    games {
                        id, name
                    }
                }
                availableCardTemplates {
                    id name fieldNames
                }
            }
            publicFieldSets {
                id, name, public, cardCount, templateCount, gameCount
                games {
                    id, name
                }
        }
        }`;
        let result = await Api.postData('/g', { query: query });
        if (result.errors) {
            return;
        }

        return result.data.currentUser;        
    }
    async loadFields(cardListId) {
        let query = `query($id: String!) {
            cardList(id: $id) {    
                id name
            }
        }`;
        let result = await Api.postData('/g', { query: query, variables: {id: cardListId} });
        if (result.errors) {
            return;
        }

        return result.data.currentUser;        
    }
    
    async save(fieldSet) {
        let query = `mutation ($input: FieldSetInput!) {
            saveFieldSet(input: $input)
        }`;
        return await Api.postData('/g', { query: query, variables: {
            input: {
                id: fieldSet.id,
                name: fieldSet.name ?? "", 
                description: fieldSet.description,                
                fields: fieldSet.fields.map(f => {
                    return {
                        name: f.name,
                        type: f.type,
                        cardTemplateId: f.cardTemplateId,
                        cardFieldName: f.cardFieldName,
                        i18n: f.i18n,
                        multi: f.multi,
                        user: !!f.user,
                    };
                }),
            }
        }});
    } 
}